export default {
  common: {
    welcome: '歡迎',
    login: '登錄',
    register: '註冊',
    logout: '退出登錄',
    home: '首頁',
    about: '關於我們',
    contact: '聯繫我們',
    Jewelry: '珠寶銷售',
    jewelrySales: '歡迎使用珠寶銷售系統！',
    pleaseInput: '請輸入',
    pleaseSelect: '請選擇',
    hello: '您好！',
    modifyPassword: '修改密碼',
    quit: '退出',
    Selection: '選擇',
    Shape: '形狀',
    Color: '顏色',
    Clarity: '淨度',
    Cut: '切工',
    Polish: '拋光',
    Sym: '對稱',
    Flu: '螢光',
    Weight: '重量',
    Ct: '克拉',
    Details: '詳情',
    Remark: '備註',
    Cert: '證書',
    CertNo: '證書號',
    OrderNo: '訂單號',
    Place: '地點',
    Price: '價格/$',
    Discount: '折扣',
    Rating: '評價',
    Year: '年份',
    Size: '尺寸',
    Table: '台面',
    Depth: '深度',
    Ratio: '比例',
    Status: '狀態',
    Action: '操作',
    Operator: '操作員',
    OrderDate: '訂單日期',
    Round: '圓形',
    Princess: '公主方',
    Radiant: '雷迪恩',
    Asscher: '阿斯切',
    Marquise: '馬眼',
    Oval: '橢圓形',
    Emerald: '祖母綠',
    Pear: '梨形',
    Heart: '心形',
    Cushion: '垫形',
    Triangle: '三角形',
    Others: '其他',
    JewelryInformation: '珠寶信息',
    Selected: '選中',
    TotalW: '總重量',
    TotalP: '總價格',
    Customer: '客戶',
    Order: '訂單',
    Orders: '我的訂單',
    Cart: '購物車',
    Listings: '鑽石列表',
    Information: '信息',
    welcome: '歡迎登錄',
    RealName: '真實姓名',
    LoginTimes: '登錄次數',
    JoinTime: '加入時間',
    LastLogin: '最後登錄',
    account: '賬號',
    oldPassword: '舊密碼',
    newPassword: '新密碼',
    confirm: '確認密碼',
    Tips: '提示',
    confirmLogout: '確認退出',
    diamondSelect: '白鑽查詢',
    colorDiamondSelect: '彩鑽查詢',
    shoppingCart: '購物車',
    orderCenter: '訂單中心',
    personalCenter: '個人中心',
    languageSwitch: '語言切換',
    Account: '賬號',
    Phone: '手機號碼',
    Company: '類型',
    Image: '圖片',
  },
  pagination: {
    total: '共 {total} 條',
    sizes: '條/頁',
    prev: '上一頁',
    next: '下一頁',
    jumper: '前往',
    page: '頁'
  },
  // 框架菜單
  menu: [{
    menuId: 0,
    home: '首頁',
    menuName: '主數據中心',
    region: '地址信息管理',
    shipper: '貨主管理',
    unit: '單位管理',
    unitMath: '物料單位換算管理',
    materialData: '物料數據管理',
    materialGroup: '物料組管理',
    delivery: '送達方管理',
    sold: '售達方管理',
    business: '事業部管理',
    carriers: '承運商管理',
    driver: '司機管理',
    carManage: '車輛管理',
    factoryDc: '工廠物流中心',
    warehouse: '倉庫管理',
    shipperWarehouseStrategy: '分倉策略管理',
    unloading: '卸貨點管理',
    message: '經銷商管理',
    material: '物料信息'
  }, {
    menuId: 1,
    menuName: '系統管理',
    user: '用戶管理',
    role: '角色管理',
    resource: '資源管理',
    appRight: '應用權限管理',
    dataRight: '數據權限組管理',
    org: '組織機構管理',
    systemlog: '系統日誌管理',
    portlog: '接口日誌管理'
  }, {
    menuId: 2,
    menuName: '訂單中心',
    sourceOrder: '來源訂單管理',
    orderManage: '訂單管理',
    inStorage: '入庫分倉管理',
    outStorage: '出庫分倉管理',
    outStoragePlan: '出庫計劃管理',
    inStoragePlan: '入庫計劃管理',
    distribution: '配送單管理',
    processOrder: '加工訂單管理',
    storage: '庫存量管理',
    warning: '預警管理',
    salesOrderList: '銷售訂單列表',
    buyOrderList: '採購訂單列表',
    moveOrderList: '移庫訂單列表',
    inventoryInquireList: '庫存查詢列表',
    deliverList: '配送單列表'
  }, {
    menuId: 3,
    menuName: '可視化中心',
    processExecution: '單據可視化流程'
  }, {
    menuId: 4,
    menuName: '規則配置中心',
    orderBase: '訂單基礎節點管理',
    orderNodeClass: '訂單節點分類管理',
    orderExtension: '訂單節點擴展配置',
    addressMap: '地址映射配置',
    orgStrategy: '組織分倉策略',
    orgRelationship: '組織關係管理',
    nodeGroup: '訂單節點管理'
  }],
  // 框架頂部右側
  navTop: {
    search: '請輸入要搜索的內容',
    admin: '管理員',
    exit: '退出',
    logo: {
      title: '益海嘉里',
      des: 'OMS平台'
    }
  },
  // 公共按鈕
  button: {
    add: '增加',
    remove: '刪除',
    update: '修改',
    view: '查看',
    enable: '啟用',
    disable: '禁用',
    cancel: '取消',
    confirm: '確定',
    copy: '複製',
    logoutSuccess: '退出成功',
    tip: '提示',
    save: '保存',
    close: '關閉',
    search: '查詢',
    reset: '重置',
    importExcel: '導入',
    exportExcel: '導出',
    upload: '上傳',
    download: '下載',
    resetPassword: '重置密碼',
    login: '登錄',
    getCertNo: '獲取證書號',
    export: '導出選中',
    exportAll: '導出全部',
    batchCancel: '批量取消',
    batchOrder: '批量下單',
    batchToCart: '加購物車',
    uploadRapnet: '上傳Rap',
  },
  // 操作成功/失敗提示信息
  msg: {
    success: '操作成功',
    error: '操作失敗',
    wechatDownloadTip: '微信瀏覽器暫不支持文件下載，請使用瀏覽器打開進行下載操作'
  }
} 


// WEBPACK FOOTER //
// ./src/i18n/zh-TW.js